import { $Formutil } from 'react-bootstrap-formutil';

export interface AssetsInfoFormutilType {
    net_assets: string;
    net_current_assets: string;
    net_year_income: string;
    stk_kl: string;
}

export interface AssetsInfoProps {
    $formutil: $Formutil<AssetsInfoFormutilType>;
    disabled?: boolean;
}
